import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import logo from './viident-logo-transparent.png';

function Writer() {
  return (
    <div className="App">
            <div className="App-main">
                <img src={logo} className="App-logo" alt="logo" />
                <p className="App-main-text">
                    Senior Writer
                </p>

                <p>Viident Publishing Inc.<br/>
                Cincinnati/Northern Kentucky<br/>
                Full-Time</p>

                <h3>About the Role</h3>

                <p>Are you ready to change some lives? If you thrive in a fast-paced environment where one day you're a copywriter showing off your dazzling wit through deeply moving copy, and the next you're knee-deep in research for our next life-changing book, then you might be in the right place. We are looking for a high-capacity writer who is willing to do whatever it takes to meet people where they are and lead them to become the best-version-of-themselves.

                <br/>
                <br/>

                Developing content that has the chance to change a life isn't easy. It takes commitment, honesty, and collaboration. We make commitments to meet our deadlines, research best practices, create multiple iterations on the road to the best option, and enjoy working together for a great mission. If you've got grit, thick skin, an ability to work quickly, and a willingness to serve where you're needed most, then we want to hear from you!
                
                <br/>
                <br/>
                
                The Senior Writer will work with the editorial team in all phases of the review and drafting process of books published under Viident and its various imprints. This person will work closely with editors, production/operations, and designers to ensure world-class titles are delivered accurately and on schedule.
                
                <br/>
                <br/>
                
                This position is an integral part of a small and committed team. A “whatever it takes” mentality combined with a “no task is too big or too small” attitude is required to succeed in this role. The position consists of a 5-day in-office schedule, Monday-Friday, occasionally requiring availability outside of normal business hours.</p>

                <br/>

                <h4>Responsibilities include:</h4>
                <p>
                    Draft clear, compelling content across platforms (including but not limited to: journals or workbooks, introductions, conclusions, press releases, online/social media copy, and other promotional material)
                    <br/><br/>
                    Write, revise, and structure book content to align with purpose, tone, and target audience
                    <br/><br/>
                    Research industry-related topics and trends to develop original content
                    <br/><br/>
                    Edit and proofread content for grammar, clarity, accuracy, and consistency
                    <br/><br/>
                    Collaborate with editorial, design, web development, and founder to align content with branding and campaign goals
                    <br/><br/>
                    Optimize content for search engines (SEO) using targeted keywords and best practices
                    <br/><br/>
                    Stay up to date with content trends, tools, and best practices to continuously enhance quality
                    <br/><br/>
                    Fact-check all content to ensure accuracy and reliability of information
                    <br/><br/>
                    Ensure consistency in voice, style, and formatting
                    <br/><br/>
                    Other general administrative duties where necessary
                </p>

                <h4>Qualifications:</h4>
                <ul>
                    <li>A passion for reading and books</li>
                    <li>Desire to add enormous value to a growing independent publishing company</li>
                    <li>Hunger to grow professionally and learn from those around you </li>
                    <li>Willingness to work collaboratively in a team setting</li>
                    <li>Passion for owning multiple projects with competing work priorities and regular changes</li>
                    <li>Previous writing experience</li>
                    <li>Meticulous attention to detail and exemplary organizational skills</li>
                    <li>Excellent written and verbal communication skills</li>
                </ul>

                <h4>If You Are...</h4>
                <ul>
                    <li>Committed - Deeply passionate about the mission of Viident and willing to act as a leading voice; eager to go the extra mile in a fast-paced, deadline-driven environment</li>
                    <li>Coachable - Committed to best practices and continuous learning; genuine desire to give and receive feedback to master the Viident voice</li>
                    <li>Aware - A thorough understanding of our audience and the ability to talk to them in a way that is simple, relevant, and inspiring</li>
                </ul>

                <h4>You would be a great fit for Viident!</h4>

                <p>Viident creates content that helps people become the-best-version-of-themselves. If you are a qualified candidate interested in getting paid to grow professionally, make a difference, add tremendous value to our team, and change lives, we look forward to hearing from you.</p>

                <br/>

                <h4>Compensation Package:</h4>
                <p>Salary $50,000 to $70,000 + Full Health Care Benefits + 3% 401k Match</p>
                <p>Job Type: Full-Time</p>
                <p>Pay: $50,000.00 - $70,000.00 per year</p>
                <p>Benefits: 401(k) matching, Health Insurance</p>
                <p>Schedule: Monday to Friday</p>
                <p>Work Location: In person</p>

                <h4>If you are interested, please email your cover letter and resume to careers@viident.com.</h4>
            </div>
            <br/>
            <br/>
            <footer className="App-footer">
              <br/>
              <Link to="/careers" className="App-link">Back to Careers</Link>
              <br/>
              <p className="quote-text">
                "Books change our lives, because we become the books we read."
              </p>
              <p>
                Matthew Kelly
              </p>
            </footer>
    </div>
  );
}

export default Writer;